import { Component, OnInit } from '@angular/core';
import { HttpserviceService } from '../../../service/http.service.service';
import { Router } from '@angular/router';
import { UtilsService } from '../../../service/utils.service';
import { GlobalConfig } from '../../../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import { debug } from 'console';

declare var initEditor: any;
declare var setDatatoEditor: any;
declare var getWebRemarks: any;
declare var setLatLong: any;

@Component({
  selector: 'app-copy-property',
  templateUrl: './copy-property.component.html',
  styleUrls: ['./copy-property.component.css']
})
export class CopyPropertyComponent implements OnInit {
  copy: any = 0;
  propertyId: any = '';
  src: any = '';
  apiUrl: any = '';
  propertyForm: FormGroup;
  formErrors: any;
  submitted: Boolean = false;
  isEdit: Boolean = false;
  country: any[] = [];
  state: any[] = [];
  city: any[] = [];
  areas: any[] = [];
  district: any[] = [];
  subArea: any[] = [];
  subSubArea: any[] = [];
  categories: any[] = [];
  facilities: any[] = [];
  facility: any[] = [];
  agents: any[] = [];

  properties: any = {
    countryId: 1,
    stateId: 1,
    cityId: 2,
    districtId: 1,
    areaId: '',
    userId: '',
    subAreaId: '',
    subSubAreaId: '',
    propertyRefNo: '',
    propertyType: '',
    listingAgent: '',
    listingAgentEmail: '',
    listingAgentPhone: '',
    unitReferenceNo: '',
    rentType: '',
    furnishing: '',
    propertyName: '',
    propertyTitle: '',
    permitNo: '',
    price: '',
    bedrooms: '',
    noOfBathroom: '',
    companyName: '',
    featured: 0,
    facility: [],
    webRemarks: '',
    unitBuiltupArea: '',
    images: [],
    longitude: '',
    latitude: ''
  };
  subAreaList: any = [];
  subSubAreaList: any = [];
  propertyImages: any = { id: '', basc64: '', imageUrl: '', index: -1 };
  constructor(
    private route: ActivatedRoute,
    private servicesComponent: HttpserviceService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) {
    this.propertyId = route.snapshot.params['id'];
  }

  agentId: any = '';
  isAgent: Boolean = false;

  ngOnInit() {
    this.isEdit = false; 
    const roles = localStorage.getItem("role");

    this.setPermissions(roles);

    this.apiUrl = this.config.apiRootUrl;
    this.getAreas();
    this.getSubArea();
    this.getSubSubArea();
    this.getCategories();
    this.getFacilities();
    this.GetAgents();

    if (this.agentId > 0) {
      this.properties.userId = this.agentId;
    }
    new initEditor();
  }

  GetAgents() {
    this.servicesComponent.GetAgents()
      .then((response: any) => {
        if (response.success) {
          this.agents = response.receiveObj;
          if (this.properties.userId > 0) {
            this.properties.companyName = (this.agents.filter(a => Number(a.id) === Number(this.properties.userId)))[0].companyName;
          }

        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getPropertyDetail(id) {
    this.servicesComponent.getPropertyDetail(id)
      .then((response: any) => {
        if (response.success) {          
          this.properties = response.receiveObj;
          this.facility = response.receiveObj.facility;
          this.properties.images = []; // response.receiveObj.images;
          this.mapFacilitiesId();
          this.subAreaList = this.subArea.filter(a => Number(a.areaId) === Number(this.properties.areaId))
          this.subSubAreaList = this.subSubArea.filter(a => Number(a.subAreaId) === Number(this.properties.subAreaId))
          setDatatoEditor(response.receiveObj.webRemarks);
          this.propertyId = 0;
          this.properties.id = 0;
          this.properties.cdnImageCount = 0;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  onChangeWebRemarks() {
    this.properties.webRemarks = getWebRemarks();
  }

  addProperty(form) {
    this.submitted = false;
    var latLong = setLatLong();
    this.properties.latitude = latLong[0];
    this.properties.longitude = latLong[1];
    if (form.valid) {

      this.properties.facility = this.facilities;
      //if (this.properties.images.length == 0) {
      //  this.submitted = true;
      //  return
      //}
      this.properties.webRemarks = getWebRemarks();
      this.servicesComponent.saveProperty(this.properties)
        .then((response: any) => {
          if (response.receiveObj.success) {
            this.router.navigate(['./property']);
            this.toastr.success('property add successfully.', 'Success!');
          }
        })
        .catch(error => {
          // console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  updateProperty(form) {
    this.submitted = false;
    var latLong = setLatLong();
    this.properties.latitude = latLong[0];
    this.properties.longitude = latLong[1];
    if (form.valid) {
      this.properties.facility = this.facilities;

      //if (this.properties.images.length == 0) {
      //  this.submitted = true;
      //  return
      //}
      this.properties.webRemarks = getWebRemarks();
      this.servicesComponent.saveProperty(this.properties)
        .then((response: any) => {
          if (response.receiveObj.success) {
            this.router.navigate(['./property']);
            this.toastr.success('property update successfully.', 'Success!');
          }
        })
        .catch(error => {
          // console.log(error);
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        });
    } else {
      this.submitted = true;
    }
  }

  getState() {
    this.servicesComponent.getState()
      .then((response: any) => {
        if (response.success) {
          this.state = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCountry() {
    this.servicesComponent.getCountry()
      .then((response: any) => {
        if (response.success) {
          this.country = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCity() {
    this.servicesComponent.getCity()
      .then((response: any) => {
        if (response.success) {
          this.city = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getAreas() {
    this.servicesComponent.getArea()
      .then((response: any) => {
        if (response.success) {
          this.areas = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getDistricts() {
    this.servicesComponent.getDistricts()
      .then((response: any) => {
        if (response.success) {
          this.district = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });

  }

  getSubArea() {
    this.servicesComponent.getSubArea()
      .then((response: any) => {
        if (response.success) {
          this.subArea = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getSubSubArea() {

    this.servicesComponent.getSubSubArea()
      .then((response: any) => {
        if (response.success) {
          this.subSubArea = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getCategories() {
    this.servicesComponent.getCategories()
      .then((response: any) => {
        if (response.success) {
          this.categories = response.receiveObj;
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  getFacilities() {
    this.servicesComponent.getFacilities()
      .then((response: any) => {
        if (response.success) {
          this.facilities = response.receiveObj;
          if (this.propertyId > 0) {
            this.getPropertyDetail(this.propertyId);
          }
        } else {
          this.toastr.error('Some error occured, Please contact admin.', 'Error!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  mapFacilitiesId() {
    this.facility.forEach(a => {
      this.facilities.forEach(b => {
        if (a.id === b.id) {
          b.facilityValueCheck = true;
        }
        else if (a.id! === b.id) {
          b.facilityValueCheck = false;
        }
      });
    });
  }

  onFileChange($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const extension = this.getFileExtension(file.name);
    if (extension.toLowerCase() === 'png' || extension.toLowerCase() === 'gif' ||
      extension.toLowerCase() === 'jpg' || extension.toLowerCase() === 'svg') {
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        that.propertyImages.basc64 = loadEvent.target.result;
        that.propertyImages.index = that.properties.images.length;
        that.properties.images.push(that.propertyImages);
        that.reInit();
      };
      myReader.readAsDataURL(file);
    } else {
      this.toastr.info('Please select valid file.', 'Info!');
    }
  }

  reInit() {
    this.propertyImages = { id: '', basc64: '', imageUrl: '', index: -1 };
  }

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  deleteImage(value, index) {
    this.servicesComponent.deletePropertyImage(value)
      .then((response: any) => {
        if (response.receiveObj == true) {
          this.properties.images.splice(index, 1);
          this.toastr.success('property image delete successfully.', 'Success!');
        }
      })
      .catch(error => {
        // console.log(error);
        this.toastr.error('Some error occured, Please contact admin.', 'Error!');
      });
  }

  deleteImageArray(index) {
    if (this.properties.images.length > 0) {
      this.properties.images.splice(index, 1);
    }
  }

  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":
            data.agentId = userId;
            data.isAgent = true;
            break;

          default:
            break;
        }

      });
    }
  }

  changeArea(areaId) {
    this.subAreaList = this.subArea.filter(a => Number(a.areaId) === Number(areaId))
  }

  onChangeSubArea(subId) {
    this.properties.propertyName = (this.subArea.filter(a => Number(a.id) === Number(subId)))[0].subarea;
    this.subSubAreaList = this.subSubArea.filter(a => Number(a.subareaId) === Number(subId));
  }

  onChangeAgent(id) {
    this.properties.companyName = (this.agents.filter(a => Number(a.id) === Number(id)))[0].companyName;
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/propertiesManagement/property/copy-property/copy-property.component.ts